module.exports = __webpack_public_path__ + "static/why-the-allies-won-97f43e5c0bf996d6b965c3cbedd4bbeb.jpg";